<template>
  <section class="container-fluid">
    <div class="row">
      <div class="col">
        <CCard>
          <CCardHeader>
            <slot name="header">
              <div class="row">
                <div class="col"><CIcon name="cil-grid" />Profesores</div>
                <div class="col">
                  <router-link
                    to="/profesores/crear"
                    custom
                    v-slot="{ href, navigate }"
                  >
                    <a
                      :href="href"
                      class="float-right btn btn-sm btn-primary"
                      @click="navigate"
                    >
                      <CIcon size="sm" name="cil-plus" />
                    </a>
                  </router-link>
                </div>
              </div>
              <div class="row d-block d-lg-none d-xl-none">
                <div class="col">
                  <div class="form-group">
                    <label class="control-label" for="person_fullname"
                      >Nombre completo</label
                    >
                    <input
                      type="text"
                      v-model="columnFilter.person_fullname"
                      class="form-control form-control-sm"
                      id="person_fullname"
                      @change="filterTable"
                    />
                  </div>
                </div>
              </div>
            </slot>
          </CCardHeader>
          <CCardBody>
            <CDataTable
              class="table-bordered c-table c-table-main"
              :hover="true"
              :striped="true"
              :bordered="true"
              :small="true"
              :items="items"
              :fields="fields"
              :sorter="{ external: true, resetable: true }"
              @update:sorter-value="filterTable"
              :columnFilter="{ external: true, lazy: true }"
              @update:column-filter-value="filterTable"
              :column-filter-value.sync="columnFilter"
              :loading="loading"
            >
              <template #no-items-view>
                <div class="no-items-view">
                  {{
                    loading
                      ? "Cargando datos..."
                      : "No existen profesores registrados"
                  }}
                  <CIcon name="cil-ban" size="xl" v-if="!loading"></CIcon>
                </div>
              </template>
              <!-- filters -->
              <template #person_enabled-filter>
                <v-select
                  :options="enabledOptions"
                  label="label"
                  :reduce="(enabledOption) => enabledOption.code"
                  v-model="columnFilter.person_enabled"
                  @input="filterTable"
                ></v-select>
              </template>
              <template #detail-filter>
                <b-button
                  @click="reload"
                  variant="secondary"
                  size="sm"
                  title="Recargar tabla"
                >
                  <CIcon size="sm" name="cil-reload" />
                </b-button>
                <b-button
                  @click="clean"
                  variant="secondary"
                  size="sm"
                  title="Limpiar filtros"
                >
                  <CIcon size="sm" name="cil-filter-x" />
                </b-button>
              </template>
              <!-- data -->
              <template #id="{ index }">
                <td>{{ (page - 1) * limit + (index + 1) }}</td>
              </template>

              <template #person_phone="{ item }">
                <td>
                  {{ item.person_phone ? item.person_phone : "" }}
                </td>
              </template>

              <template #person_email="{ item }">
                <td>
                  {{ item.person_email ? item.person_email : "" }}
                </td>
              </template>

              <template #person_enabled="{ item }">
                <td>
                  <CBadge color="success" v-if="item.person_enabled == true"
                    >Activo</CBadge
                  >
                  <CBadge color="danger" v-else>Inactivo</CBadge>
                </td>
              </template>
              <template #detail="{ item }">
                <td>
                  <b-button-group size="xs">
                    <b-button
                      @click="modalCourseOfferedList(item.id)"
                      variant="info"
                      title="Ver cursos"
                    >
                      <CIcon size="sm" name="cil-list" title="Ver cursos" />
                    </b-button>
                    <b-button
                      @click="modalTeacherScheduleList(item.id)"
                      variant="primary"
                      title="Ver horarios"
                    >
                      <CIcon size="sm" name="cil-clock" title="Ver horarios" />
                    </b-button>
                    <!-- Restablecer contraseña usuario -->
                    <b-button
                      @click="modalResetPassword(item.user_id)"
                      variant="info"
                      title="Restablecer contraseña"
                      id="btn-reset-password"
                    >
                      <CIcon size="sm" name="cil-lock-locked" />
                    </b-button>
                    <b-button
                      :to="{ path: 'profesores/editar/' + item.id }"
                      variant="warning"
                      title="Editar"
                    >
                      <CIcon size="sm" name="cil-pencil" />
                    </b-button>
                    <b-button
                      @click="modalDelete(item.id)"
                      variant="danger"
                      title="Eliminar"
                      v-if="userAuth.id !== item.id"
                    >
                      <CIcon size="sm" name="cil-trash" />
                    </b-button>
                  </b-button-group>
                </td>
              </template>
            </CDataTable>
          </CCardBody>
          <div>
            <CPagination
              :activePage.sync="page"
              :pages="pages"
              size="sm"
              align="center"
              @update:activePage="updateTable"
            />
            <TableRecords
              :total="total"
              :loading="loading"
              :from="from"
              :to="to"
              :page="page"
            />
          </div>
        </CCard>
      </div>
    </div>
    <section v-if="modShowDelTeacher">
      <TeacherDeleteModal
        :id_teacher="id_teacher"
        :modShowDelTeacher="modShowDelTeacher"
        @teacherDeleteModal="afterDeleteTeacher"
      ></TeacherDeleteModal>
    </section>
    <section v-if="modShowCoursesOfferedList">
      <CoursesOfferedListModal
        :teacher_id="id_teacher"
        :modShowCoursesOfferedList="modShowCoursesOfferedList"
        @coursesOfferedListModal="afterCoursesOfferedList"
      ></CoursesOfferedListModal>
    </section>
    <section v-if="modShowTeacherScheduleList">
      <TeacherScheduleListModal
        :id_teacher="id_teacher"
        :modShowTeacherScheduleList="modShowTeacherScheduleList"
        @teacherScheduleListModal="afterTeacherScheduleList"
      ></TeacherScheduleListModal>
    </section>
    <section v-if="modShowUserResetPassword">
      <UserResetPassword
        :user_id="user_id"
        :modShowUserResetPassword="modShowUserResetPassword"
        @userResetPassword="afterResetPasswordUser"
      ></UserResetPassword>
    </section>
  </section>
</template>
<script>
import { BAlert, BButton, BButtonGroup } from "bootstrap-vue";
import TableRecords from "@/components/shared/TableRecords";
import { Utils } from "@/plugins/utils";
import Constants from "@/plugins/constants";
//services
import Teachers from "@/plugins/services/teachers";
//components
import TeacherDeleteModal from "@/entities/teachers/TeacherDeleteModal";
import CoursesOfferedListModal from "@/entities/courses-offered/CoursesOfferedListModal";
import TeacherScheduleListModal from "@/entities/teachers/TeacherScheduleListModal";
import UserResetPassword from "@/entities/users/UserResetPassword";

export default {
  name: "TeachersList",
  components: {
    BAlert,
    BButton,
    BButtonGroup,
    TableRecords,
    UserResetPassword,
    TeacherDeleteModal,
    CoursesOfferedListModal,
    TeacherScheduleListModal,
  },
  data() {
    return {
      fields: [
        {
          key: "id",
          label: "#",
          sorter: false,
          filter: false,
          _style: "width: 8px;",
        },
        {
          key: "person_fullname",
          label: "Nombre Completo",
          _style: "min-width:150px;",
        },
        {
          key: "person_phone",
          label: "Teléfono",
          _style: "width: 12.5%;",
        },
        {
          key: "person_mobile",
          label: "Celular",
          _style: "width: 12.5%;",
        },
        {
          key: "user_username",
          label: "Usuario",
          _style: "width: 20%;",
        },
        {
          key: "person_enabled",
          label: "Estado",
          filter: true,
          _style: "width:140px;",
        },
        {
          key: "detail",
          label: "",
          sorter: false,
          _style: "width: 110px;",
        },
      ],
      items: [],
      columnFilter: { column: null, asc: false, person_enabled: true },
      enabledOptions: Constants.enabledOptions,
      page: 0,
      pages: 0,
      limit: 10,
      from: 0,
      to: 0,
      total: 0,
      loading: true,
      id_teacher: 0,
      modShowDelTeacher: false,
      modShowCoursesOfferedList: false,
      modShowTeacherScheduleList: false,
      modShowUserResetPassword: false,
    };
  },
  computed: {
    userAuth() {
      return this.$store.state.userAuth;
    },
  },
  created() {
    let colFilter = this.$store.state.columnFilter;
    if (colFilter) {
      if (colFilter.name == "teachers") {
        this.page = this.$store.state.columnFilter.page;
        this.columnFilter = this.$store.state.columnFilter.columnFilter;
      }
    }
    this.getAll(this.columnFilter, this.page);
  },
  methods: {
    getAll(q = null, page = null) {
      this.loading = true;
      Utils.columnFilter("teachers", q, page);
      Teachers.all(q, this.limit, page).then((res) => {
        this.loading = false;
        this.items = res.data.data;
        this.page = res.data.current_page;
        this.pages = res.data.last_page;
        this.total = res.data.total;
        this.from = res.data.from;
        this.to = res.data.to;
      });
    },
    updateTable(page) {
      this.getAll(this.columnFilter, page);
    },
    filterTable(columnFilter) {
      this.columnFilter = { ...this.columnFilter, ...columnFilter };
      this.getAll(this.columnFilter);
    },
    clean() {
      this.columnFilter = { column: null, asc: false, person_enabled: true };
      this.getAll(this.columnFilter);
    },
    reload() {
      this.getAll(this.columnFilter, this.page);
    },
    modalDelete(id) {
      this.modShowDelTeacher = true;
      this.id_teacher = id;
    },
    modalCourseOfferedList(id) {
      this.modShowCoursesOfferedList = true;
      this.id_teacher = id;
    },
    modalTeacherScheduleList(id) {
      this.modShowTeacherScheduleList = true;
      this.id_teacher = id;
    },
    afterDeleteTeacher(response) {
      if (
        response.data != null ||
        response.status == 404 ||
        response.status == 500
      ) {
        this.reload();
      }
      this.modShowDelTeacher = response.modalShow;
    },
    afterCoursesOfferedList(response) {
      if (
        response.data != null ||
        response.status == 404 ||
        response.status == 500
      ) {
        this.reload();
      }
      this.modShowCoursesOfferedList = response.modalShow;
    },
    afterTeacherScheduleList(response) {
      if (
        response.data != null ||
        response.status == 404 ||
        response.status == 500
      ) {
        this.reload();
      }
      this.modShowTeacherScheduleList = response.modalShow;
    },
    modalResetPassword(id) {
      this.user_id = id;
      this.modShowUserResetPassword = true;
    },
    afterResetPasswordUser(response) {
      if (
        response.data != null ||
        response.status == 404 ||
        response.status == 500
      ) {
        this.reload();
      }
      this.modShowUserResetPassword = response.modalShow;
    },
  },
};
</script>
